import { type ComponentProps, memo } from 'react';

export type AssetModalContentDesktopLayoutHeaderProps = Pick<ComponentProps<'header'>, 'children'>;

export const AssetModalContentDesktopLayoutHeader = memo(({ children }: AssetModalContentDesktopLayoutHeaderProps) => {
  return (
    <header className="absolute inset-x-0 top-0 z-10 flex h-16 w-full shrink-0 items-center ads:bg-glass/70 bg-gray-1/70 px-4 ads:text-metadata text-gray-10">
      {children}
    </header>
  );
});

AssetModalContentDesktopLayoutHeader.displayName = 'AssetModalContentDesktopLayoutHeader';
